import {ReactNode} from "react";

import {IntegrationFormData, IntegrationListData} from "@/lib/types/integrations.ts";
import {EditIntegrationModalAction} from "@/pages/integrations/edit/EditIntegrationModalAction.tsx";
import {integrationListToForm} from "@/pages/integrations/integrations.types.ts";

type IntegrationActionEditProps = {
  integration: IntegrationListData;
  className?: string;
  toolTip?: ReactNode;
  children?: ReactNode;
  show: boolean;
  setShow: (show: boolean) => void;
  setNewIntegration?: (newIntegration: IntegrationFormData) => void;
};

export const IntegrationActionEdit = ({integration, show, setShow, setNewIntegration}: IntegrationActionEditProps) => {
  return (
    <EditIntegrationModalAction
      formId={`form-integration`}
      show={show}
      setShow={setShow}
      integration={integrationListToForm(integration)}
      setNewIntegration={setNewIntegration}
    />
  );
};
